import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Placeholder,
} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm, useFieldArray } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import fileUploader from "../../../../utilities/fileUploader";
import { catchAsync, checkResponse } from "../../../../utilities/utilities";
import {
  ADDAPPINTRO,
  APPINTRODETAIL,
  HOTELLIST,
  ROOMADD,
  ROOMESSENTAILLIST,
  ROOMLIST,
  ROOMTYPE,
  ROOMUPDATE,
  UPDATEAPPINTRO,
} from "../../../../services/ApiCalls";
import Loader from "../../../../components/Common/Loader";
import { useTranslation } from "react-i18next";
import uploadMultipleFiles from "../../../../utilities/uploadMultipleFiles";

const appIntroSchema = z.object({
  short_description: z.string().min(1, "Short description is required"),
  description: z.string().min(1, "Description is required"),
  media: z.array(z.string()).min(3, "At least Three image is required").max(3, "At max three images required"),
});

const CONSTANT_PAYLOAD = {
  type: "customer",
  lang: "English",
  media_type: "image",
};
const AddAppIntro = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const [introData, setIntroData] = useState(null);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [imgloader, setImgLoader] = useState(false);
  const [loader, setLoader] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
    control
  } = useForm({
    resolver: zodResolver(appIntroSchema),
    defaultValues: {
      short_description: "",
      description: "",
      media: [],
    },
    values: {
      short_description: introData?.short_description ?? "",
      description: introData?.description ?? "",
      media: introData?.media?.map((ele) => ele?._id) ?? [],
    },
  });






  const handleImageChange = catchAsync(async (e) => {
    setImgLoader(true);

    const files = Array.from(e.target.files);
    if (!files.length) return setImgLoader(false);

    // ⬇️ call multi-file uploader ONCE
    const res = await uploadMultipleFiles(files);

    if (Array.isArray(res)) {
      const uploadedIds = res.map(item => item._id).filter(Boolean);
      const urls = res.map(item => item.link)

      const updated = [...(watch("media") || []), ...uploadedIds];

      setValue("media", updated, { shouldValidate: true });

      setImagePreviews([...imagePreviews, ...urls]);
    }

    setImgLoader(false);
  });

  const handleRemoveImage = (index) => {
    const updated = (watch("media") || []).filter((_, i) => i !== index);
    const updatedUrls = (imagePreviews || []).filter((_, i) => i !== index);
    setValue("media", updated, { shouldValidate: true });
    setImagePreviews(updatedUrls);
  };

  const submitHandler = catchAsync(async (data) => {
    const body = {
      ...data,
      ...CONSTANT_PAYLOAD,
      ...(id && { _id: id }),
    };
    const res = await (id ? UPDATEAPPINTRO(body) : ADDAPPINTRO(body))
    const success = checkResponse({ res, showSuccess: true });
    if (success) navigate(`/appintro?page=${page}`);
  });

  const handleCancel = () => navigate(`/appintro?page=${page}`);

  const fetchIntro = async () => {
    setLoader(true);


    try {

      const res = await APPINTRODETAIL(id);
      console.log("res==========================", res);
      const success = checkResponse({ res, showSuccess: true, setLoader });
      setIntroData(res?.data?.data);
      if (res?.data?.data?.media?.length) {

        setImagePreviews(res?.data?.data?.media?.map((ele) => ele?.link))
      }


    } catch (err) {

    }
    setLoader(false);
  }

  useEffect(() => {
    if (id) {
      fetchIntro();
    }
  }, [])

  return (
    <>
      {loader && <Loader />}
      <section className="addRoom position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to={`/appintro?page=${page}`}
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {id ? t("appIntro.editAppIntro") : t("appIntro.addAppIntro")}
                </h4>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >
                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row className="justify-content-between">
                    <Col lg="12" className="my-2">
                      <label>{t("appIntro.columns.shortDescription")}</label>
                      <input
                        className="form-control"
                        {...register("short_description")}
                      />
                      {errors.short_description && (
                        <p className="text-danger">{errors.short_description.message}</p>
                      )}
                    </Col>

                    <Col lg="12" className="my-2">
                      <label>{t("appIntro.columns.description")}</label>
                      <textarea
                        rows={4}
                        className="form-control"
                        {...register("description")}
                      />
                      {errors.description && (
                        <p className="text-danger">{errors.description.message}</p>
                      )}
                    </Col>


                    <Col lg="12" className="my-2">
                      <label className=" text-muted ps-2 m-0">
                        Upload Images
                      </label>
                      <div
                        className="border border-2 border-dashed rounded d-flex flex-column align-items-center justify-content-center p-4 bg-light"
                        style={{ cursor: "pointer", minHeight: "140px" }}
                        onClick={() =>
                          document.getElementById("imageUploadInput").click()
                        }
                      >
                        <i className="bi bi-cloud-upload fs-1 text-muted"></i>
                        <p className="m-0 text-muted">
                          Click or Drag & Drop to Upload
                        </p>
                        <input
                          id="imageUploadInput"
                          type="file"
                          accept="image/*"
                          multiple
                          className="d-none"
                          onChange={handleImageChange}
                        />
                      </div>

                      {errors.images && (
                        <p className="text-danger mt-1">
                          {errors.images.message}
                        </p>
                      )}

                      <div className="d-flex flex-wrap gap-2 mt-3">
                        {imgloader ? (
                          <div
                            style={{ height: 120, width: 120 }}
                            className="d-flex align-items-center justify-content-center border rounded"
                          >
                            Loading...
                          </div>
                        ) : (
                          imagePreviews.map((src, i) => (
                            <div
                              key={i}
                              style={{
                                width: 120,
                                height: 120,
                                position: "relative",
                              }}
                              className="border rounded overflow-hidden shadow-sm"
                            >
                              <img
                                src={src}
                                alt={`preview-${i}`}
                                className="w-100 h-100 object-fit-cover"
                              />
                              <button
                                type="button"
                                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 rounded-circle"
                                onClick={() => handleRemoveImage(i)}
                              >
                                ✕
                              </button>
                            </div>
                          ))
                        )}
                      </div>
                      {errors.media && (
                        <p className="text-danger">{errors.media.message}</p>
                      )}
                    </Col>



                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-center gap-10">
                        <Button
                          type="button"
                          onClick={handleCancel}
                          className="commonBtn GreyBtn"
                        >
                          Cancel
                        </Button>
                        <Button type="submit" className="commonBtn">
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddAppIntro;
